// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3UZLY","header":"MessagesList_header__KpHEr","chat":"MessagesList_chat__28iGi"};